import { List } from "@app/domains/shared/design-system";
import styled from "styled-components";

export const ListItem = styled(List.Item)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
